import { defaultConfig, plugin } from '@formkit/vue'
import config from '../../../formkit.config'

export function install(app) {
  app.use(plugin, defaultConfig(config))
}
